import { useNavigate } from "react-router-dom";
import { HbrShareIcon } from "./newComponents/Mycustomsvgicons";

const DevotionListContent = ({bookid,title,image}) => {
    const navigate = useNavigate();
    

    const shareBlogPost=async()=>{
        if(navigator.share){
            try{
                await navigator.share({
                    title: `${title}`,
                    text: `Every word of God for daily living`,
                    url: `https://horemowbookreaderlite.web.app/devotionenglish/${title}/${bookid}`,
                });
            }catch{
            }
        }else{
        }
    };


    return ( 
        <div  className="devotionContainer flex-column2">
            <p style={{color:"#f1356d",fontWeight:"bolder"}}>{title}</p>
            
            <img src={image} alt="book Cover" />
            <div className="bookbottom flex-spacebetween">

                <button onClick={()=>navigate(`/devotionenglish/${title}/${bookid}`)} 
                        style={{
                            border:"none",
                            borderRadius:"10px",
                            backgroundColor:"#1C1F2E80",
                            padding:"10px",
                            color:"white",
                            fontWeight:"bold",
                            cursor:"pointer"
                        }}>
                    Read
                </button>

                <div style={{
                    borderRadius:"50%",
                    backgroundColor: "#1C1F2E80",
                    padding:"10px"
                }}>
                    <HbrShareIcon width="1.7em" height="1.7em" fillColour="#FFFFFF" handleClick={shareBlogPost}/>
                </div>
            
            </div>
        </div>
     );
}
export default DevotionListContent;